import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";

import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Container,TabContent, TabPane, Collapse, NavLink, NavItem, Nav, Row, Col,Label, Input,Button, CardTitle, Badge, ModalFooter, InputGroup, InputGroupText } from "reactstrap";
import { products, } from "../../common/data/ecommerce";
import {  Modal,ModalBody, ModalHeader} from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { AddZone, disableZone, enableZone, GetlisteZones, updateZone, UploadFileZone } from '../../services/ZonesServices/Api';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
import { UpdateMemeberProfile } from "../../services/ProfileServices/Api";
import Dropzone from "react-dropzone";
import { Form } from "react-router-dom";
import config from '../../config'
import { AddPage, disablePage, enablepage, GetlistePages, removePage, updatePage, UploadFilePage } from "../../services/PageServices/Api";
import { colors } from "../../helpers/colors";
import ReactQuill from "react-quill";
import { AvField, AvForm } from "availity-reactstrap-validation";

const PageInfo = () => {
  const [modalUpdateIsOpen,setmodalUpdateIsOpen] = useState(false)
  const [ListZones,setListZones] = useState([])
  const [User,setUser] = useState()
  const [dropdownValues, setDropdownValues] = useState({});
  const  [openmodal, setopenModal] = useState(false)
  const [activeTabJustify,setactiveTabJustify] = useState("1")
  const [memberSelected , setmemberSelected] = useState()
  const [selectedCity , setselectedCity]  = useState("")
  const [NamePage_FR , setNamePage_FR]  = useState("")
  const [NamePage_Ar , setNamePage_Ar]  = useState("")
  const [NamePage_En , setNamePage_En]  = useState("")
  const [ZoneOpened , setZoneOpened] = useState({})
  const [tel , settel]  = useState("")
  const [ShowConfirmModal, setShowConfirmModal] = useState(false)
  const [ShowConfirmModalII, setShowConfirmModalII] = useState(false)
  const [ZoneSelected , setZoneSelected]  = useState("")
  const  [openedZone, setopenedZone] = useState()

  const [DesPage_Fr , setPage_Fr]  = useState("")
  const [DesPage_Ar , setPage_Ar]  = useState("")
  const [DesPage_Eng , setPage_Eng]  = useState("")

  const [adr_ferm , setadr_ferm]  = useState("")
  const [Email, setEmail] = useState()
  const [DaysSelected, setDaysSelected] = useState([])
  const [openmodalevaluate, setopenmodalevaluate] = useState(false)
  const [evaluatYear, setevaluatYear] = useState('')
  const [evaluatCmnt, setevaluatCmnt] = useState('')
  const [PageBlock, setPageBlock] = useState('')

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [ShowZones,setShowZones] = useState()
 
  const [ShowConfirmRemove, setShowConfirmRemove] = useState(false)
  const [errorsizeFile , seterrorsizeFile] = useState(false)
  const [activeTab, setactiveTab] = useState("1")



  

  const handleClickMember = (member) =>{
     setZoneOpened(member) 
     seterrorsizeFile(false)
     setactiveTab('1')
     setNamePage_FR(member['title_fr'])
     setNamePage_Ar(member['title_ar'])
     setNamePage_En(member['title_en'])
     setPage_Fr(member['description_fr'])
     setPage_Ar(member['description_ar'])
     setPage_Eng(member['description_en'])
     setShowZones(member["showzones"])

     setopenModal(true)
  }



  const  toggleCustomJustified = (tab) => {
		setactiveTabJustify(tab)
	}

  const  handleSelectCity = async (selectedGroup) => {
    console.log(selectedGroup)
    setselectedCity(selectedGroup);
  };


  const optionBlock = [
	{
		options: [
			{ label: "Explorez le Zoo", value: "Explorez le Zoo" },
			{ label: "Expériences", value: "Expériences" },
			{ label: "Préparez votre visite", value: "Préparez votre visite" },
			{ label: "Plan du Zoo", value: "Plan du Zoo" },

		]
	},
];



  const columns = useMemo(
    () => [
      {
        Header: "Image Page",
        accessor: "img",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Nom de la page",
        accessor: "title_fr",
        disableFilters: true,
        filterable: false,
      },
      
      {
        Header: "Description",
        accessor: "description_fr",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "disable",
        disableFilters: true,
        filterable: false,
      }
    
    ],
  );

  if((User?.role == 2 || User?.role == 3) ){
    columns.push({
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      filterable: false,
    })
  }



  const GetData = async () =>{
    await GetlistePages().then(res =>{
      console.log(res)
      const filteredZones = res.filter(zone => zone.disable == false);

      //  for (let index = 0; index < res.length; index++) {
      //   res[index].nbr_ani = res[index].animaux.length
      //  }

      setListZones(res)
      setsetFilterData(res)
    
    }).catch(err =>{
      console.log(err)
    })
  }

    useEffect(() =>{
      const Data = JSON.parse(localStorage.getItem("authUser"))
      setUser(Data)

      GetData()
    },[])

    const initForm = () =>{
      setSelectedFiles([])
      setNamePage_Ar("")
      setNamePage_FR("")
      setNamePage_En("")
      setPage_Ar("")
      setPage_Eng("")
      setPage_Fr("")
      setZoneOpened({})
    //   setShowZones(false)
    }

    const handleAcceptedFiles = (files) => {
      const updatedFiles = files
        .filter((file) => {
          if (file.size > 50097152) { 
            seterrorsizeFile(true)
            return false;
          }
          seterrorsizeFile(false)
          return true;
        })
        .map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            htmlFormattedSize: htmlFormatBytes(file.size),
          })
        );
    
      setSelectedFiles(updatedFiles);
    };

    const htmlFormatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const formatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

    const handleRemoveFile = (index) => {
      setSelectedFiles(prevFiles => {
          const updatedFiles = [...prevFiles];
          updatedFiles.splice(index, 1);
          return updatedFiles;
      });
  };


  const handleupdateZone = async () =>{
    if(selectedFiles.length !== 0 ){
      
    const formData = new FormData();
    formData.append('file', selectedFiles[0]);
      await UploadFileZone(formData).then(async res =>{
        console.log(res)
      ZoneOpened['title_fr'] = NamePage_FR
      ZoneOpened['description_fr'] = DesPage_Fr
      ZoneOpened['title_ar'] = NamePage_Ar
      ZoneOpened['description_ar'] = DesPage_Ar
      ZoneOpened['title_en'] = NamePage_En
      ZoneOpened['description_en'] = DesPage_Eng
      ZoneOpened['img'] = res
      ZoneOpened['updatedAt'] = new Date()
    //   ZoneOpened['block'] = PageBlock.value
      ZoneOpened['showzones'] = ShowZones == true ? 1 : 0


      await updatePage(ZoneOpened).then(res =>{
        console.log(res.status)
        if (res.status === 200) {
  
          toastr.success('la zone ' + NamePage_FR + " était bien modifié" )
          setopenModal(false)
          initForm()
  
        } else {
          toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
  
        }
      })
    })
  } else {
    // ZoneOpened['block'] = PageBlock.value
    ZoneOpened['title_fr'] = NamePage_FR
    ZoneOpened['description_fr'] = DesPage_Fr
    ZoneOpened['title_ar'] = NamePage_Ar
    ZoneOpened['description_ar'] = DesPage_Ar
    ZoneOpened['title_en'] = NamePage_En
    ZoneOpened['description_en'] = DesPage_Eng
    ZoneOpened['updatedAt'] = new Date()
    ZoneOpened['showzones'] = ShowZones == true ? 1 : 0


    await updatePage(ZoneOpened).then(res =>{
      console.log(res.status)
      if (res.status === 200) {

        toastr.success('la zone ' + NamePage_FR + " était bien modifié" )
        setopenModal(false)
        initForm()

      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

  }
}


 
  const addZone = async () =>{

    console.log(selectedFiles[0])
    console.log(typeof(selectedFiles[0]))

    const formData = new FormData();
    formData.append('file', selectedFiles[0]);

    await UploadFilePage(formData).then(async res =>{
      console.log(res)

    const DataPost = {
      "block" : PageBlock.value,
      "description_fr": DesPage_Fr,
      "title_fr": NamePage_FR,
      "description_ar": DesPage_Ar,
      "title_ar": NamePage_Ar,
      "description_en" : DesPage_Eng,
      "title_en" : NamePage_En,
      "img" : res,
      "ref" : NamePage_FR
    }
    await AddPage(DataPost).then(res =>{
      console.log(res.status)
      if (res.status === 201) {

        toastr.success('la zone ' + NamePage_FR + " était bien ajouté" )
        setopenModal(false)
        initForm()
        GetData()


      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

    })

    // const blobData = await fetch(URL.createObjectURL(selectedFiles[0])).then((res) => res.blob());
    // const blob = new Blob([blobData], { type: selectedFiles[0].type });
    // formData.append('files', blob, selectedFiles[0].name);


  }

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const handleAddnewZone = () => {
    setZoneOpened({})
    initForm()
    setopenModal(true)
  }

  const handleClickDisable = async () => {

    await disablePage(openedZone).then((res) =>{
      if (res.status === 200) {
      GetData()
      setShowConfirmModal(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
    })

  }

  const handleClickRemove = async () => {

    await removePage(openedZone).then((res) =>{
      if (res.status === 200) {
      GetData()
      setShowConfirmRemove(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
    })

  }

  const handleClickEnable = async (Zone) =>{

    await enablepage(openedZone).then((res) =>{
      console.log(res)
      if (res.status === 200) {
        toastr.success("la zone était bien activé" )
        GetData()
        setShowConfirmModalII(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
     })

  }


  // const updateZone = async () =>{
  //   console.log(memberSelected.profile)
  //   const Data = JSON.parse(localStorage.getItem("authUser"))
  //   memberSelected.profile['adrs_res'] = DesZone
  //   memberSelected.profile['Tel'] = tel
  //   memberSelected.profile['adrs_ferme'] = adr_ferm
  //   memberSelected.profile['City'] = selectedCity?.value
  //   memberSelected.profile['days_dispo'] = JSON.stringify(DaysSelected)

  //   const DataProfile = { Data : memberSelected.profile }
    
  //   await UpdateMemeberProfile(Data.token, DataProfile ).then(res =>{
  //     setopenModal(false)
  //     if(res['status'] == "success"){
  //       toastr.success('le profil de ' + NameZone + " était bien misé à jour" )
  //     }
  //   }).catch(err =>{
  //     toastr.error("Erreur lors de mises à jour le profile ")
  //   })
  // }


  const [FilterData, setsetFilterData] = useState([])
  const [searchValue, setsearchValue] =useState('')
  const handleSearch = (e) => {
    const value = e.target.value
    // setsearchValue(value)
    const filtered = ListZones.filter(item => {
      // Filter based on matching any field you want (e.g., name or description)
      return item.title_fr.toLowerCase().includes(value.toLowerCase()) || 
             item.description_fr.toLowerCase().includes(value.toLowerCase());
    });

    setsetFilterData(filtered); // Update filtered data state
  };



  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Page informations"
            breadcrumbItems={[]}
          />
        
          <Card>
           <div style={{display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-between'}}>
           <div style={{margin : 10, width : "70%", alignItems : 'center'}}>
           <AvForm >
               <InputGroup style={{marginBottom : 0}}>
                   <AvField
                   style={{ width : 500, marginBottom : 0}}
                   type="text"
                   name="search"
                   value={searchValue}
                   onChange={handleSearch}
                   placeholder="Recherche..."
                   />
                   {searchValue && (
                       <InputGroupText>
                       <Button color="link" onClick={{}}>
                           <i className="fa fa-times-circle" /> 
                       </Button>
                       </InputGroupText>
                   )}
               </InputGroup>
               </AvForm> 
           </div>
           {(User?.role == 2 || User?.role == 3) &&
         <div className="d-flex justify-content-end m-2 mt-2">
               <Button color="success" onClick={handleAddnewZone}>
                   Ajouter une page
               </Button>
         </div>
         }
         </div>
  
            <CardBody>
            <TableContainer
                columns={columns || []}
                data={FilterData || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                // openModalUpdate={openModal}
                // isAddOptions={true}
                ShowPaggination={false}
                handleClickRow={handleClickMember}
                handleClickDisable={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmModal(true)
                }}
                handleClickRemove={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmRemove(true)
                }}
                handleClickEnable={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmModalII(true)

                }}
                dropdownData = {dropdownValues}
                userData={User}
              />  
            </CardBody>
          </Card>
                <Modal
                    size="xl"
                    isOpen={openmodal}
                    toggle={() =>{setopenModal(false)}}
                >
              
                <ModalHeader
                  toggle={() =>{setopenModal(false)}} 
                  close={
                    <i class="fas fa-times" style={{fontSize  : 25, cursor : 'pointer'}} onClick={() =>{setopenModal(false)}}></i>
                  }
                >
                  Information de la page {ZoneOpened['title_fr']}
                </ModalHeader>
                <ModalBody>
                  <Row>
                  <Col lg="6">
                  <Label className="form-label" htmlFor="basicpill-firstname-input1">Image</Label>
                    <Dropzone
                        onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                                <div className="dz-message needsclick" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                        <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                    </div>
                                    <div style={{flexDirection  : 'column', display : 'flex'}}>
                                    <span style={{fontSize : 14}}>Déposez les fichiers ici ou cliquez pour télécharger.</span>
                                    {errorsizeFile == true &&
                                      <span style={{fontSize : 12, fontWeight  : 'bold', color : colors.red}}>Le fichier à déployer ne doit pas dépasser 2 Mo.</span>
                                    }
                                    </div>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                    </Col>
                    <Col lg="6">
                    {selectedFiles.some(file => file.type.startsWith('image/')) && (
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                        <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          {selectedFiles.filter(file => file.type.startsWith('image/')).map((file, index) => (
                            <Col key={index} xs="6" sm="4" md="3" lg="2">
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                style={{ width: '220%', height: "220%", marginBottom: '10px', }}
                              />
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )}
                     {(!isObjectEmpty(ZoneOpened) && selectedFiles.length == 0) &&
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                      <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          <Col xs="6" sm="4" md="3" lg="2">
                           
                            <img
                              src={config.path + ZoneOpened["img"]}
                              alt={"icon"}
                              style={{ width: '220%', height: "220%", marginBottom: '10px', }}
                            />
                          </Col>
                      </Row>
                    </div> 
                    }


                    {selectedFiles.length > 0 && (
                        <Card className="mt-3">
                            <CardBody>
                                <CardTitle>Fichier Sélectionné</CardTitle>
                                {selectedFiles.map((file, index) => (
                                    <Row key={index} className="align-items-center mb-2">
                                        <Col className="col-auto">
                                            <h6 className="text-truncate font-size-14 mb-0">{file.name}</h6>
                                        </Col>
                                        <Col>
                                            <Badge color="primary">{formatBytes(file.size)}</Badge>
                                        </Col>
                                        <Col className="col-auto">
                                            <Button color="danger" size="sm" onClick={() => handleRemoveFile(index)}><i className="ri-delete-bin-2-line"></i></Button>
                                        </Col>
                                    </Row>
                                ))}
                               
                            </CardBody>
                        </Card>
                    )}
                    </Col>
                    </Row>
                <Row className="mb-3 mt-3">
                    {/* <Col lg="8" >
                    <Label className="form-label">Block</Label>
					<Select
						value={PageBlock}
						onChange={(Block) =>{setPageBlock(Block)}}
						options={optionBlock}
						classNamePrefix="select2-selection"
					/>
                    </Col> */}
                    <Col lg="4" >
                    <Input className="form-check-input" type="checkbox" value={ShowZones} checked={ShowZones} id="type" onChange={(e) =>{ 
                            setShowZones(!ShowZones)
                        }} />
                    <Label className="form-check-label" htmlFor="type" style={{marginLeft : 5}}>
                        Aficher les biozones 
                    </Label>
                    </Col>
                </Row>
                <React.Fragment>
                      <Nav pills className="navtab-bg nav-justified mt-2">
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer",
                                      // border : activeTab !== "1" ? "1px solid #e4e4e4" : "none",
                                     }}
                                    className={classnames({
                                      active: activeTab == "1"
                                    })}
                                    onClick={() => {
                                     setactiveTab("1")
                                    }}
                                  >
                                    Francais
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer",
                                      // border : activeTab !== "2" ? "1px solid #e4e4e4" : "none",
                                    }}
                                    className={classnames({
                                      active: activeTab == "2"
                                    })}
                                    onClick={() => {
                                      setactiveTab("2")
                                    }}
                                  >
                                    Arabe
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer",
                                      // border : activeTab !== "3" ? "1px solid #e4e4e4" : "none",
                                     }}
                                    className={classnames({
                                      active: activeTab == "3"
                                    })}
                                    onClick={() => {
                                        setactiveTab("3")
                                    }}
                                  >
                                    Englais
                                  </NavLink>
                                </NavItem>
                              
                        </Nav>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1" className="p-3">
                            <Row>
                              <Col lg="12">
                                <div className="mb-3">
                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom de la page </Label>
                                    <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NamePage_FR } onChange={(e) =>setNamePage_FR(e.target.value)} />
                                </div>
                                </Col>
                                
                            </Row>
                            <Row>
                            <Col lg="12">
                                  {/* <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                      <textarea id="basicpill-address-input1" className="form-control" rows="5" onChange={(e) =>setDesc_Fr(e.target.value)} value={DesZone_Fr }></textarea>
                                  </div> */}
                                  <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                   <ReactQuill
                                      value={DesPage_Fr}
                                      onChange={(value) =>setPage_Fr(value)}
                                      style={{ height: '150px' }}  
                                      theme="snow"
                                      modules={ {
                                        toolbar: [
                                          ['bold', 'italic', 'underline'], 
                                          [{ list: 'ordered' }, { list: 'bullet' }],  
                                        ],
                                      }}  
                                      formats={[
                                        'bold', 'italic', 'underline',  
                                        'list',
                                      ]}   
                                  />
                                   
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId="2" className="p-3">
                            <Row>
                              <Col lg="12">

                              <div className="mb-3">
                                  <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom de la page</Label>
                                  <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NamePage_Ar } onChange={(e) =>setNamePage_Ar(e.target.value)} />
                              </div>
                              </Col>
                              
                            </Row>
                            <Row>
                            <Col lg="12">
                                  {/* <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                      <textarea id="basicpill-address-input1" className="form-control" rows="5" onChange={(e) =>setDesc_Ar(e.target.value)} value={DesZone_Ar }></textarea>
                                  </div> */}
                                  <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                  <ReactQuill
                                      value={DesPage_Ar}
                                      onChange={(value) =>setPage_Ar(value)}
                                      style={{ height: '150px' }}  
                                      theme="snow"
                                      modules={ {
                                        toolbar: [
                                          ['bold', 'italic', 'underline'], 
                                          [{ list: 'ordered' }, { list: 'bullet' }],  
                                        ],
                                      }}  
                                      formats={[
                                        'bold', 'italic', 'underline',  
                                        'list',
                                      ]}   
                                  />
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId="3" className="p-3">
                            <Row>
                              <Col lg="12">
                              <div className="mb-3">
                                  <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom de la page</Label>
                                  <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NamePage_En } onChange={(e) =>setNamePage_En(e.target.value)} />
                              </div>
                              </Col>
                              
                            </Row>
                            <Row>
                            <Col lg="12">
                                  {/* <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                      <textarea id="basicpill-address-input1" className="form-control" rows="5" onChange={(e) =>setDesc_Eng(e.target.value)} value={DesZone_Eng }></textarea>
                                  </div> */}
                                  <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                  <ReactQuill
                                      value={DesPage_Eng}
                                      onChange={(value) =>setPage_Eng(value)}
                                      style={{ height: '150px' }}  
                                      theme="snow"
                                      modules={ {
                                        toolbar: [
                                          ['bold', 'italic', 'underline'], 
                                          [{ list: 'ordered' }, { list: 'bullet' }],  
                                        ],
                                      }}  
                                      formats={[
                                        'bold', 'italic', 'underline',  
                                        'list',
                                      ]}   
                                  />
                              </Col>
                            </Row>
                          </TabPane>

                        </TabContent>
                      </React.Fragment>
              </ModalBody>
                      {!isObjectEmpty(ZoneOpened) ? 
                      <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                        {(User?.role == 2 || User?.role == 3) && 
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                              onClick={handleupdateZone}
                          >
                              Mise à jour
                          </Button>
                        }
                      </div>
                       :
                      <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                              onClick={addZone}
                          >
                              Enregistrer
                          </Button>
                      </div>
                  }

          </Modal>

          <Modal
                size="xl"
                isOpen={openmodalevaluate}
                toggle={() =>{setopenmodalevaluate(false)}}
                >
                <ModalHeader >
                  Evaluation le membre : {memberSelected?.NomComplet}
                </ModalHeader>
                <ModalBody>
                    <Row>
                      <Col lg="12">
                          <div className="mb-3">
                              <Label className="form-label" htmlFor="basicpill-address-input1">Année d'évaluation</Label>
                              <Input type="text" className="form-control" id="basicpill-phoneno-input3" onChange={(e) =>setevaluatYear(e.target.value)} value={evaluatYear}/>
                          </div>
                      </Col>
                    </Row>
                    <Row>
                    <Col lg="12">
                        <div className="mb-3">
                            <Label className="form-label" htmlFor="basicpill-address-input1">Commentaire</Label>
                            <textarea id="basicpill-address-input1" className="form-control" rows="2" onChange={(e) =>setevaluatCmnt(e.target.value)} value={evaluatCmnt}></textarea>
                        </div>
                    </Col>
                    </Row>
                </ModalBody>
                <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                          >
                              Enregistrer
                          </Button>
                      </div>
          </Modal>

          <Modal
               isOpen={ShowConfirmModal}
               toggle={() => setShowConfirmModal(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModal(false) }>
                Désactiver la page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous désactiver cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModal(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickDisable} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          <Modal
               isOpen={ShowConfirmRemove}
               toggle={() => setShowConfirmRemove(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmRemove(false) }>
                Supprimer la page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous supprimer cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmRemove(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickRemove} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          <Modal
               isOpen={ShowConfirmModalII}
               toggle={() => setShowConfirmModalII(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModalII(false) }>
                Activer la Page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous activer cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModalII(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickEnable} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          
        </Container>
        {/* <Modal
            isOpen={modalUpdateIsOpen}
            onRequestClose={closeModal} 
            style={customStyles}
          ></Modal> */}
      </div>
    </React.Fragment>
  );
};

export default PageInfo;
